import styled from 'styled-components';
import colors from '../../../config/colors';

const InputImg = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  >  img,
  > svg {
    position: absolute;
    z-index: 1;
    top: 25px;
    left: 14px;
    pointer-events: none;
    width: 16px;
    height: 16px;
    transform: translateY(-50%);
    stroke: ${colors.BLACK};
  }

  .cities-clear {
    position: absolute;
    z-index: 1;
    right: 14px;
    top: 25px;
    transform: translateY(-50%);
    font-size: 15px;
    display: flex;
    align-items: center;
    color: ${colors.BLACK};

    svg {
      width: 12px;
      height: 12px;
    }
  }

  .select-wrapper {
    position: relative;

    i {
      left: 40px;
    }
  }

  .rbt .rbt-input-main,
  input {
    padding-left: 40px !important;
    padding-right: 30px !important;
  }
`;

export default InputImg;
